import * as bpac from "../utils/bpac.js";
const STORAGE_KEY = "bpacPrinters";

export async function LoadPrinters() {
  console.log("LoadPrinters called");
  console.log("Reading from localStorage key:", STORAGE_KEY);
  const storedValue = localStorage.getItem(STORAGE_KEY);
  console.log("Raw stored value:", storedValue);
  var printers = JSON.parse(storedValue || "[]");
  console.log("Parsed printers from storage:", printers);
  const doc = bpac.IDocument;

  const current = await doc.GetPrinterName();
  console.log("Current printer from bpac:", current);

  if (current && !printers.includes(current)) {
    console.log("Current printer not in list, adding it");
    printers.push(current);
    savePrinters(printers);
  } else {
    console.log("Current printer already in list or no current printer");
  }
  console.log("LoadPrinters finished. Final printers:", printers);
}
export function AddPrinter(printerName: string) {
  console.log("AddPrinter called with:", printerName);
  if (!printerName || printerName.trim() === "") {
    console.log("Empty printer name, returning existing printers");
    return GetPrinters();
  }
  const printers = GetPrinters();
  console.log("Current printers in storage:", printers);
  if (!printers.includes(printerName)) {
    printers.push(printerName);
    console.log("Printer not in list, adding. New list:", printers);
    savePrinters(printers);
  } else {
    console.log("Printer already in list");
  }
  const result = GetPrinters();
  console.log("Returning printers:", result);
  return result;
}
export function ClearPrinters() {
  localStorage.removeItem(STORAGE_KEY);
}

export function GetPrinters(): string[] {
  const stored = localStorage.getItem(STORAGE_KEY);
  console.log("GetPrinters - raw storage value:", stored);
  const result = JSON.parse(stored || "[]");
  console.log("GetPrinters - returning:", result);
  return result;
}

export function savePrinters(printers: string[]) {
  console.log("savePrinters called with:", printers);
  try {
    const serialized = JSON.stringify(printers);
    console.log("Serialized printers:", serialized);
    localStorage.setItem(STORAGE_KEY, serialized);
    console.log("Saved to localStorage. Verifying...");
    const verification = localStorage.getItem(STORAGE_KEY);
    console.log("Verification read from localStorage:", verification);
  } catch (error) {
    console.error("Error saving printers to localStorage:", error);
  }
}
export function IsBpacInstalled(): boolean {
  if (bpac.IsExtensionInstalled() == false) {
    const agent = window.navigator.userAgent.toLowerCase();
    const isedge = agent.indexOf("edg") !== -1;
    if (isedge)
      window.open(
        "https://microsoftedge.microsoft.com/addons/detail/brother-bpac-extension/kmopihekhjobijiipnloimfdgjddbnhg",
        "_blank"
      );
    const ischrome =
      agent.indexOf("chrome") !== -1 && agent.indexOf("opr") === -1;
    if (ischrome)
      window.open(
        "https://chrome.google.com/webstore/detail/ilpghlfadkjifilabejhhijpfphfcfhb",
        "_blank"
      );
    return false;
  }
  return true;
}
